/*
 * wechat.js
 * Copyright (C) 2019 faircat <faircat@localhost.localdomain>
 *
 * Distributed under terms of the MIT license.
 */

import request from '@/utils/request'

export function updateConfig (data) {
  return request({
    url: '/wechat/api/card_app/updateConfig',
    method: 'post',
    data
  })
}
export function fetchPartnerList (query) {
  return request({
    url: '/wechat/api/pay/index',
    method: 'get',
    params: query
  })
}
export function createPartner (data) {
  return request({
    url: '/wechat/api/pay/insert',
    method: 'post',
    data
  })
}

export function updatePartner (data) {
  return request({
    url: '/wechat/api/pay/update',
    method: 'post',
    data
  })
}

export function fetchWechatList (query) {
  return request({
    url: '/wechat/api/card_app/index',
    method: 'get',
    params: query
  })
}

export function fetchWechat (id) {
  return request({
    url: '/wechat/api/card_app/view',
    method: 'get',
    params: { id }
  })
}

export function createWechat (data) {
  return request({
    url: '/wechat/api/card_app/insert',
    method: 'post',
    data
  })
}

export function updateWechat (data) {
  return request({
    url: '/wechat/api/card_app/update',
    method: 'post',
    data
  })
}

export function deleteWechat (id) {
  return request({
    url: '/wechat/api/card_app/delete',
    method: 'post',
    params: { id }
  })
}



// WEBPACK FOOTER //
// ./src/card/api/wechat.js